import { Container, Grid } from '@mui/material'
import { useGetOrderByIdQuery } from 'api/adminSlice'
import { useParams } from 'react-router-dom'
import { OrderCard, PaymentCard, ServicePointCard, UserCard } from './components'
import { useState } from 'react'

export default function AdminOrderDetails() {
    const { id } = useParams()
    const { data: order } = useGetOrderByIdQuery(id)

    return (
        <Container sx={{ my: 20 }}>
            <Grid container spacing={25}>
                <Grid item md={6} sm={12} xs={12}>
                    <UserCard user={order?.user} />
                </Grid>
                {
                    !!order?.servicePoint &&
                    <Grid item md={6} sm={12} xs={12}>
                        <ServicePointCard servicePoint={order?.servicePoint} />
                    </Grid>
                }
                <Grid item md={6} sm={12} xs={12}>
                    <PaymentCard order={order} />
                </Grid>
                <Grid item md={6} sm={12} xs={12}>
                    <OrderCard order={order} />
                </Grid>
            </Grid>
        </Container>
    )
}
